export default __webpack_public_path__ + "static/teen-card-29657e33b35723acda6f820a855b235d.png";